if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        const image = event.target.closest('.media-wrapper.is-active .media--adapt img');
        if (!image) return;

        const media = image.closest('.media-wrapper');
        this.toggleDetailedZoom(media, event);
      });
    }

    hide() {
      this.resetDetailedZoom();
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.resetDetailedZoom();
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');

      const container = this.querySelector('[role="document"]');
      container.scrollTop = 0;
      container.scrollLeft = 0;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    toggleDetailedZoom(media, event) {
      const container = this.querySelector('[role="document"]');

      if (media.classList.contains('is-zoomed')) {
        media.classList.remove('is-zoomed');
        media.style.removeProperty('--product-modal-zoom-width');
        container.scrollTop = 0;
        container.scrollLeft = 0;
        return;
      }

      const image = media.querySelector('img');
      const imageRect = image.getBoundingClientRect();
      const focusX = (event.clientX - imageRect.left) / imageRect.width;
      const focusY = (event.clientY - imageRect.top) / imageRect.height;
      const sourceWidth = Math.max(image.naturalWidth, Number(image.getAttribute('width')) || 0);
      const zoomWidth = Math.max(container.clientWidth, Math.min(sourceWidth, container.clientWidth * 2));

      media.style.setProperty('--product-modal-zoom-width', `${zoomWidth}px`);
      media.classList.add('is-zoomed');

      requestAnimationFrame(() => {
        container.scrollLeft = Math.max(0, focusX * media.scrollWidth - container.clientWidth / 2);
        container.scrollTop = Math.max(0, focusY * media.scrollHeight - container.clientHeight / 2);
      });
    }

    resetDetailedZoom() {
      this.querySelectorAll('.media-wrapper.is-zoomed').forEach((media) => {
        media.classList.remove('is-zoomed');
        media.style.removeProperty('--product-modal-zoom-width');
      });
    }
  });
}
